var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxAssetReportActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    stroke: "#D9A62E",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85558 15.5C8.69843 15.402 8.58244 15.3491 8.49701 15.2734C7.22239 14.1477 5.9515 13.0184 4.67938 11.8901C4.00465 11.2916 3.32992 10.6932 2.65332 10.0963C2.51302 9.97282 2.43195 9.83768 2.57537 9.69036C2.72254 9.53948 2.90214 9.59739 3.08236 9.66648C4.77042 10.3132 6.46347 10.9507 8.14593 11.6071C8.4359 11.7204 8.60115 11.7036 8.83001 11.5075C11.4622 9.24839 14.1081 7.00043 16.7503 4.74942C16.8363 4.67627 16.9099 4.57568 17.0159 4.53962C17.1313 4.5005 17.319 4.47916 17.3988 4.52945C17.4824 4.5828 17.4905 4.72961 17.4998 4.83782C17.5042 4.88557 17.4306 4.9379 17.3913 4.98717C14.6693 8.38629 11.948 11.7859 9.22225 15.1825C9.1337 15.2927 8.99838 15.3776 8.85558 15.4995V15.5Z",
    fill: "#D9A62E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxAssetReportActive);
export default __webpack_public_path__ + "static/media/checkbox_asset_report_active.32a841200dea88349fd6d1d934862b7f.svg";
export { ForwardRef as ReactComponent };